module.exports = __webpack_public_path__ + "static/media/angle-left.1a37dd9f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/angle-left.svg
 ** module id = 872
 ** module chunks = 0
 **/